<div *ngIf="caseResume">
    <i *ngIf="caseResume?.updatedAt">Resumen actualizado el {{caseResume?.updatedAt | date:'short'}} por {{caseResume?.updatedByUser?.name}}.</i>
    <i *ngIf="!caseResume?.updatedAt">Resumen generado el {{caseResume?.createdAt | date:'short'}} por {{caseResume?.createdByUser?.name}}</i>
</div>
<div *ngIf="!caseResume">
    <p>No hay resumen generado para este caso.</p>
</div>
<div [innerHTML]="caseResume?.text" class="mt-4">
</div>
<p-message *ngIf="!caseResume && !hasEnoughLogs" severity="warn" styleClass="mt-4 w-full"
    [text]="'Para generar un resumen con IA el expediente debe tener al menos ' + minLogsForResume + ' eventos.'">
</p-message>
<div class="flex align-items-end gap-2 mt-4">
    <p-button *ngIf="loginService.hasPermission('CASES.AI_RESUME')" label="Generar resumen con IA" severity="secondary" icon="pi pi-microchip-ai" [disabled]="!hasEnoughLogs" (click)="resumeCaseNow()" />
</div>